import { FormEvent, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { saasApi, type SaaSTenant } from '../../api/saas';

export function TenantManagerPage() {
  const [tenants, setTenants] = useState<SaaSTenant[]>([]);
  const [name, setName] = useState('');
  const [error, setError] = useState('');

  const load = () => { void saasApi.tenants().then(setTenants).catch((e) => setError(String(e))); };
  useEffect(() => { load(); }, []);

  const onCreate = async (e: FormEvent) => {
    e.preventDefault();
    if (!name) return;
    try {
      await saasApi.createTenant({ name, provision: true });
      setName('');
      load();
    } catch (err) {
      setError(String(err));
    }
  };

  return (
    <div className="mx-auto max-w-5xl p-6">
      <Link to="/saas" className="text-sm text-slate-600 hover:underline dark:text-slate-400">← Global SaaS Dashboard</Link>
      <h1 className="mt-2 text-2xl font-semibold">Tenant Manager</h1>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <form onSubmit={onCreate} className="mt-4 flex gap-2">
        <input className="flex-1 rounded border px-3 py-2 text-sm dark:border-slate-600 dark:bg-slate-900" placeholder="Tenant name" value={name} onChange={(e) => setName(e.target.value)} />
        <button type="submit" className="rounded bg-slate-900 px-4 py-2 text-sm text-white dark:bg-slate-100 dark:text-slate-900">Create &amp; Provision</button>
      </form>
      <ul className="mt-6 divide-y rounded-lg border dark:border-slate-700">
        {tenants.map((t) => (
          <li key={t.id} className="flex items-center justify-between px-4 py-3 text-sm">
            <div>
              <span className="font-medium">{t.name}</span>
              <span className="ml-2 text-slate-500">{t.slug}</span>
              <span className="ml-2 text-xs text-slate-400">{t.plan} · {t.region}</span>
            </div>
            <div className="flex items-center gap-2">
              <span className={`capitalize ${t.status === 'active' ? 'text-green-600' : t.status === 'suspended' ? 'text-red-600' : 'text-yellow-600'}`}>{t.status}</span>
              {t.status === 'active' ? (
                <button type="button" className="text-xs text-red-600 hover:underline" onClick={() => void saasApi.suspend(t.id).then(load)}>Suspend</button>
              ) : (
                <button type="button" className="text-xs text-green-600 hover:underline" onClick={() => void saasApi.activate(t.id).then(load)}>Activate</button>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
